
import { useMemo, useEffect, useState, useRef } from "react";
import axios from "axios";
import { CircularProgress, Pagination , Box} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftInput from "components/SoftInput";
import dayjs from "dayjs";

import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import Readmore from "./Readmore";
import CustomdateC from "./CustomdateC";
import ExportD from "./ExportD";
import {  ThumbsDown } from 'lucide-react'; // Import the icons
import { useRowSelect } from "react-table";
import Question from "./Question";

import { getDomainId } from '../../../utils/utils';
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../constants";


function DataTableD({
  
  entriesPerPageOptions = [5, 10, 15, 20, 25],
  canSearch = false,
  date=false,
  table,
  csv=false,
  pagination = { variant: "gradient", color: "info" },
  isSorted = true,
  noEndBorder = false,
  dateRange
}) {
 
  const columns = useMemo(() => table.columns, [table]);
  const [rows, setRows] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key :'created_at', direction:"desc"})
  const [dateRange1, setDateRange1] = useState({start_date : null, end_date: null})
  const [hoveredCountry, setHoveredCountry] =useState()
  const isFirstLoading = useRef(true)

  // const totalPages = Math.ceil(totalEntries / entriesPerPage);
  // const start = (page - 1) * entriesPerPage + 1;
  // const end = Math.min(page * entriesPerPage, totalEntries);
  const totalPages = totalEntries && entriesPerPage
  ? Math.ceil(totalEntries / entriesPerPage)
  : 1;

  const start = totalEntries === 0 ? 0 : (page - 1) * entriesPerPage + 1;
  const end = Math.min(page * entriesPerPage, totalEntries || 0);

const GetLast30Days = () => {
  const start_date = new Date()
  const end_date = new Date()
  start_date.setDate(end_date.getDate()-29)

  const formatDate = (date) =>{
    return date.toISOString().split('T')[0]
  }
  return {
    start_date : formatDate(start_date),
    end_date : formatDate(end_date)
  }
}

  
  const fetchUsers = async () => {
    if (isFirstLoading.current)
    {
      setLoading(true)
    }
    try {
      const domainId = await getDomainId();
      // const {start_date, end_date} = dateRange.start_date && dateRange.end_date ? dateRange : GetLast30Days;
      const {start_date, end_date } = dateRange1?.start_date && dateRange1?.end_date 
        ? dateRange1 : dateRange?.start_date && dateRange?.end_date ? dateRange : GetLast30Days()
      const offset = (page - 1) * entriesPerPage;  // Calculate offset
      const res = await axios.get(`${LAMBDA_BASE_URL}/dislikes`, {
        params: { 
          limit: entriesPerPage, 
          offset: offset,       
          search: search,
          sort_key :sortConfig.key, 
          sort_direction : sortConfig.direction,
          start_date: start_date,
          end_date: end_date,        
        },
        headers: {
          'DOMAIN-TOKEN': domainId
        }
      });
    const formattedRows = res.data.result.search_list.map((user) => ({
      id:user.id,
      content:{
      question:<Question text={user.question}/>,
      answer: user.answer,
      },
      // answer:<Readmore text={user.answer}/>,
      ip_address: user.ip_address, 
      created_at: dayjs(user.created_at).format('MMM D, YYYY hh:mm A'),
      // created_at: user.created_at,
      // dislikes: user.dislikes,
      
       
    }));

    setRows(formattedRows);
    setTotalEntries(res.data.result.total);
  
  } catch (err) {
    console.error("Error fetching users", err);
  } finally {
    if (isFirstLoading.current)
    {
      setLoading(false)
      isFirstLoading.current = false
    }
  }
};
  useEffect(() => {
    fetchUsers();
  }, [page, entriesPerPage, search, sortConfig, dateRange1]); 

  const handlePageChange = (event, value) => {
    setPage(value);
    
  };

  const handleEntriesPerPageChange = ({ value }) => {
    setEntriesPerPage(value);
    setPage(1);
    
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
    
  };

  const handleSort = (columnKey) =>{
    setSortConfig((prevSortConfig) =>{
      let newDirection ="asc";
      if(prevSortConfig.key === columnKey && prevSortConfig.direction === "asc")
      {
        newDirection ='desc'
      }
      return {key : columnKey , direction :newDirection}
    })
  }
// const handleDateRangeSelect = ({ start, end }) => {
//     let start_date = null;
//     let end_date = null;
  
//     if (start) {
//       const startDateObj = new Date(start);
//       startDateObj.setHours(0, 0, 0, 0); // ⬅️ Set to beginning of the day
//       start_date = startDateObj.toISOString();
//     }
  
//     if (end) {
//       const endDateObj = new Date(end);
//       endDateObj.setHours(23, 59, 59, 999); // ⬅️ Set to end of the day
//       end_date = endDateObj.toISOString();
//     }
  
//     console.log("Parsed dates:", { start_date, end_date });
//     setDateRange1({ start_date, end_date });
//   };
    const handleDateRangeSelect = ({start , end}) => {
          // console.log("selected dates:", start, end)
          setDateRange1({ start_date : start, end_date : end })
    }
   

  return (
    <TableContainer sx={{ boxShadow: "none", minHeight: "450px" }}>
        {loading ? (
          <Box 
            display = "flex"
            justifyContent = "center"
            alignItems = "center"
            minHeight = "300px"
            >
              <CircularProgress color="teal" />
            </Box>
        ) : ( 
          <>
                {(entriesPerPageOptions || canSearch || date || csv) && (
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={1}>
          <SoftBox display="flex" alignItems="center">
            <SoftSelect
              defaultValue={{ value: entriesPerPage, label: entriesPerPage }}
              options={entriesPerPageOptions.map((entry) => ({
                value: entry,
                label: entry,
              }))}
              onChange={handleEntriesPerPageChange}
              size="small"
            />
            <SoftTypography variant="caption" color="secondary">
              &nbsp;&nbsp;entries per page
            </SoftTypography>
          </SoftBox>
          {canSearch && (
            <SoftBox width="12rem" ml="auto">
              <SoftInput placeholder="Search..." value={search} onChange={handleSearchChange} />
            </SoftBox>
          )}
           {date && (
             <SoftBox display ="flex" justifyContent="space-between" alignItems="center" marginLeft="10px">
             <CustomdateC onRangeSelect={handleDateRangeSelect}/>
           </SoftBox>
          )}
           {csv && (
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" marginLeft="10px" p={0}>
             <ExportD searchQuery = {search} startDate = {dateRange1?.start_date || dateRange?.start_date} endDate = {dateRange1?.end_date || dateRange?.end_date} filename="ansera_dislike_details.csv"/>        
            </SoftBox>
          )}
        </SoftBox>
      )}
     
      <Table>
    <SoftBox component="thead">
      {columns.map((column, key) => {
        const isSortable = !["content", "dislikes"].includes(column.Header);
    
        return (
    //     <DataTableHeadCell
    //   key={key}
    //   width={column.width || "auto"}
    //   align={column.align || "left"}
    //   onClick={isSortable ? () => handleSort(column.accessor) : undefined}
    //   sorted={
    //     isSortable && sortConfig.key === column.accessor
    //       ? sortConfig.direction
    //       : "none"
    //   }
    //   showSortIcon={!["content", "dislikes"].includes(column.accessor)} 
    //   style={{
    //     cursor: isSortable ? "pointer" : "default",
    //     userSelect: "none",
    //   }}
    // >
    //   {column.Header}
    // </DataTableHeadCell>

    <DataTableHeadCell
          key ={key}
          width = {column.width || "auto"}
          align = {column.align || "left"}
          onClick = {isSortable ? () => handleSort(column.accessor) : undefined}
          sorted = {
            isSortable && sortConfig.key === column.accessor
            ? sortConfig.direction : 'none'
          }
          showSortIcon = {!["content", "dislikes"].includes(column.accessor)}
          style = {{
            cursor : isSortable ? "pointer" : "default",
            useSelect : "none"
          }}
    >
      {column.Header}
    </DataTableHeadCell>
        );
      })}
    </SoftBox>
        
              <TableBody>
  {rows.map((row, key) => (
    <TableRow key={key}>
      {Object.entries(row).map(([colKey, cell], index) => {
        if (colKey === "id" || colKey === "country") return null; 

        return (
          <DataTableBodyCell
            key={index}
            align="left"
            colSpan={colKey === "content" ? columns.length : 1}
          >
            {colKey === "content" ? (
              <>
                {/* <strong>Q: {cell.question}</strong> */}
                <div style={{display : "flex"}}>
                  <strong>Q:</strong>
                  <strong>{cell.question}</strong>
                </div>
                {/* <br /> */}
                <Readmore
                  text={cell.answer}
                  apiEndpoint="/api/edit-answer"
                  id={row.id}
                />
              </>
            ) : colKey === "country_flag" ? (
             
              <div
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          onMouseEnter={() => setHoveredCountry(row.id)}
          onMouseLeave={() => setHoveredCountry(null)}
        >
          <img
            src={cell} 
            alt="flag"
            style={{
              width: "34px",
              height: "26px",
              objectFit: "cover",
              border: "1px solid #ccc",
              borderRadius: "2px",
              cursor: "pointer"
            }}
          />
          <span
            style={{
              opacity: hoveredCountry === row.id ? 1 : 0,
              transition: "opacity 0.3s ease",
              pointerEvents: "none" 
            }}
          >
            {row.country}
          </span>
        </div>
         )  : colKey === "dislikes" ? (
             
           <td style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  {row.dislikes === 1 ? (
    <ThumbsDown color="red" size={20} />
  )  : null}
</td>
            ) : (
              
              cell
            )}
          </DataTableBodyCell>
        );
      })}
    </TableRow>
  ))}
</TableBody>


        <SoftBox pb={1} display="flex" justifyContent="space-between" alignItems="center" paddingTop="10px" paddingLeft="40px">
      <SoftTypography variant="button" color="secondary">
         Showing {start} to {end} of {totalEntries} entries
       </SoftTypography>
       </SoftBox>
      </Table>
      <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={1}>
      <Pagination 
      count={totalPages} 
      page={page} 
      onChange={handlePageChange}
      shape="circular" 
      color="info" />

      <SoftTypography variant="button">
          Page {page} of {totalPages}
         </SoftTypography>
    </SoftBox>
          </>
        )}
    </TableContainer>
  );
}

export default DataTableD;


